/* eslint-env node */

"use strict";

module.exports = require("./lib/addons/MomentLocaleUtils");
module.exports.localeUtils = require("./lib/addons/MomentLocaleUtils");



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-day-picker/moment.js
 ** module id = 1509
 ** module chunks = 0
 **/